/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
// import parse from "html-react-parser";
import moment from "moment";
class FriendItem extends PureComponent {
  state = {
    mouseOn: false,
  };
  componentDidMount = () => {};
  _goItem = () => {
    const { setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;
    setContentSerial(contentSerial);
    //history.push('/items/' + contentSerial)
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  render() {
    const { buyUserid, charac_img, nicName, regDate, autoFlag, wishCount } =
      this.props.childProps;

    return (
      <Fragment>
        <tr>
          <td>
            <span className="thumb">
              <img src={charac_img} />
            </span>
            {/*<span className="sns"><img src="/img/sns_katalk.png" /></span>*/}
            <b className="wh">
              {nicName}({buyUserid})
            </b>
          </td>
          <td>{moment(regDate).format("YYYY.MM.DD")}</td>
          <td>{autoFlag === "A" ? "정기결제" : "멤버십"}</td>
          <td>
            <button type="button" className="btn_on">
              찜한작품({this._CommaFormatted(wishCount)})
            </button>
          </td>
        </tr>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(FriendItem)));
